module.exports = __webpack_public_path__ + "static/media/AboutMeImage39.89cec225.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AboutMeImage39.png
// module id = 78
// module chunks = 0